// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 7: الرسائل والرؤيا
// ============================================================================
// المستويات 79-91 (13 مستوى، 39 سؤال)

export const chapter7Translations = {
  name: "الرسائل والرؤيا",
  description: "من يغلب يرث هذه الأمور... حكمة من فوق تقدس الفهم",
  
  spiritualWisdom: {
    principle: "الحكمة من فوق تقدس الفهم وتحيي الروح",
    scripture: "إن كان أحدكم تعوزه حكمة فليطلب من الله (يعقوب 1: 5)",
    application: "كل رسالة رسولية وكل رؤيا من سفر الرؤيا تثري فهمنا وتقوي رجاءنا"
  },
  
  levels: {
    79: {
      name: "الاعتقال في أورشليم",
      challenge: "أنا مستعد ليس أن أُربط فقط بل أن أموت أيضاً في أورشليم...",
      easy: {
        question: "أين تم اعتقال بولس في زيارته الأخيرة؟",
        options: ["أنطاكية", "أفسس", "أورشليم", "كورنثوس"],
        correctAnswer: 2,
        hint: "المدينة المقدسة التي كثيراً ما اضطهدت الأنبياء",
        funFact: "🏛️ أورشليم: مكان مجد ومعاناة لجميع خدام الله!"
      },
      medium: {
        question: "بماذا اتُهم بولس من قبل اليهود؟",
        options: [
          "السرقة من الهيكل",
          "تدنيس الهيكل بإدخال أمميين",
          "التجديف على موسى",
          "التمرد على روما"
        ],
        correctAnswer: 1,
        hint: "اتهام يتعلق بعالمية الإنجيل",
        funFact: "⛪ المفارقة: بولس متهم بتدنيس الهيكل الذي كرّمه بعمق!"
      },
      hard: {
        question: "كيف حوّل بولس سجنه إلى فرصة؟",
        options: [
          "هرب",
          "شهد أمام السلطات وكتب رسائله",
          "صمت",
          "فاوض على إطلاق سراحه"
        ],
        correctAnswer: 1,
        hint: "يتعلق بتحويل المحنة إلى شهادة",
        funFact: "⛓️ قيود جسدية، حرية روحية - شهادة قوية للإيمان!"
      }
    },
    
    80: {
      name: "أمام الوالي فيلكس",
      challenge: "وبينما كان يتكلم عن البر والتعفف والدينونة العتيدة...",
      easy: {
        question: "أمام أي والٍ شهد بولس بإيمانه؟",
        options: ["بيلاطس", "فيلكس", "فستوس", "غاليون"],
        correctAnswer: 1,
        hint: "والٍ معروف بجشعه",
        funFact: "⚖️ فيلكس كان يأمل في رشوة - الفساد في وجه النزاهة!"
      },
      medium: {
        question: "ما كان رد فعل فيلكس على رسالة بولس؟",
        options: [
          "اهتدى",
          "ارتعب من الخوف",
          "سخر",
          "بقي غير مبالٍ"
        ],
        correctAnswer: 1,
        hint: "الضمير المضطرب بالحقيقة",
        funFact: "😰 حتى الفاسدون يرتعبون أمام الحقيقة الإلهية - ضمير عالمي!"
      },
      hard: {
        question: "لماذا أبقى فيلكس بولس سجيناً سنتين؟",
        options: [
          "لحمايته",
          "لمصلحة سياسية وأمل في الفساد",
          "بسبب النسيان",
          "بسبب الاقتناع"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالحسابات السياسية والشخصية",
        funFact: "🏛️ العدالة البشرية الفاسدة مقابل العدالة الإلهية الكاملة - تناقض صارخ!"
      }
    },

    81: {
      name: "الاستئناف إلى قيصر",
      challenge: "إني أستأنف إلى قيصر!",
      easy: {
        question: "ما الحق الذي استدعاه بولس لتجنب المحاكمة في أورشليم؟",
        options: [
          "حق اللجوء",
          "الاستئناف إلى قيصر (مواطن روماني)",
          "حق الهروب",
          "الحماية الدبلوماسية"
        ],
        correctAnswer: 1,
        hint: "امتياز مواطنيته الرومانية",
        funFact: "🏛️ المواطنة الرومانية: جواز سفر إلهي لنقل الإنجيل إلى روما!"
      },
      medium: {
        question: "أمام من شهد بولس قبل مغادرته؟",
        options: [
          "السنهدريم",
          "الملك أغريباس وبرنيكي",
          "الجنود الرومان",
          "الحشد اليهودي"
        ],
        correctAnswer: 1,
        hint: "الملكية الهيرودسية المتهودة",
        funFact: "👑 من راعي القطعان إلى القصر الملكي - ارتقاء إلهي لبولس!"
      },
      hard: {
        question: "كيف يستخدم الله الأنظمة البشرية لخططه؟",
        options: [
          "يتجاهلها",
          "يستخدمها بعناية إلهية لإنجاز مقاصده",
          "يدمرها",
          "يعارضها دائماً"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالسيادة الإلهية على التاريخ",
        funFact: "🌐 العدالة الرومانية تصبح وسيلة للإنجيل - عناية إلهية ملحوظة!"
      }
    },

    82: {
      name: "الغرق في مالطا",
      challenge: "لا تخف يا بولس، ينبغي أن تمثل أمام قيصر...",
      easy: {
        question: "في أي جزيرة تحطمت سفينة بولس؟",
        options: ["كريت", "قبرص", "مالطا", "صقلية"],
        correctAnswer: 2,
        hint: "جزيرة صغيرة جنوب صقلية",
        funFact: "🏝️ مالطا: توقف قسري يتحول إلى رسالة مثمرة - تحويلات إلهية!"
      },
      medium: {
        question: "ما المعجزة التي أجراها بولس في مالطا؟",
        options: [
          "أهدأ العاصفة",
          "شفى والد بوبليوس ومرضى آخرين",
          "ضاعف الطعام",
          "أقام ميتاً"
        ],
        correctAnswer: 1,
        hint: "شفاءات متعددة على الجزيرة",
        funFact: "🏥 بولس: من منكوب إلى طبيب معجزي - سمعة إلهية!"
      },
      hard: {
        question: "كيف يوضح هذا الغرق أمانة الله؟",
        options: [
          "الحوادث تحدث",
          "الله يحمي ويحقق وعوده رغم العقبات",
          "بولس كان محظوظاً",
          "كان يمكن تجنبه"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالأمانة الإلهية للوعود",
        funFact: "⛈️ عاصفة، غرق، ثعبان: لا شيء يوقف الخطة الإلهية لبولس!"
      }
    },

    83: {
      name: "بولس في روما",
      challenge: "أقام سنتين كاملتين في بيت استأجره لنفسه...",
      easy: {
        question: "في أي ظروف عاش بولس في روما؟",
        options: [
          "في سجن مغلق",
          "تحت الإقامة الجبرية",
          "في حرية كاملة",
          "في المنفى"
        ],
        correctAnswer: 1,
        hint: "حرية نسبية تحت المراقبة",
        funFact: "🏠 بيت-سجن يتحول إلى مركز إرسالي - حرية في القيود!"
      },
      medium: {
        question: "ماذا فعل بولس خلال سنتيه في روما؟",
        options: [
          "استراح",
          "علّم وكتب رسائله",
          "أعدّ دفاعه",
          "قام بجولات سياحية"
        ],
        correctAnswer: 1,
        hint: "خدمة مكثفة رغم القيود",
        funFact: "✍️ رسائل السجن: أفسس، فيلبي، كولوسي، فليمون!"
      },
      hard: {
        question: "كيف أنهى بولس خدمته حسب التقليد؟",
        options: [
          "مات بمرض",
          "قُطع رأسه تحت حكم نيرون حوالي 67 م",
          "مات من الشيخوخة",
          "اختفى بشكل غامض"
        ],
        correctAnswer: 1,
        hint: "استشهاد تحت حكم الإمبراطور المجنون",
        funFact: "⚔️ 'جاهدت الجهاد الحسن، أكملت السعي' - انتصار نهائي!"
      }
    },

    84: {
      name: "الرسالة إلى أهل رومية",
      challenge: "لست أستحي بإنجيل المسيح، لأنه قوة الله للخلاص...",
      easy: {
        question: "أي رسالة تطور أكثر عقيدة الخلاص بالإيمان؟",
        options: ["1 كورنثوس", "غلاطية", "رومية", "أفسس"],
        correctAnswer: 2,
        hint: "'الكاتدرائية' اللاهوتية لبولس",
        funFact: "🏛️ رومية: تحفة لاهوتية اهتدى بها أوغسطينوس ولوثر!"
      },
      medium: {
        question: "حسب رومية، كيف يتبرر الإنسان أمام الله؟",
        options: [
          "بأعماله الصالحة",
          "بالإيمان وحده، بدون الأعمال",
          "بالذبائح",
          "بالتقليد"
        ],
        correctAnswer: 1,
        hint: "المبدأ الأساسي للإصلاح",
        funFact: "⚖️ 'البار بالإيمان يحيا' - ثورة روحية لبولس!"
      },
      hard: {
        question: "ما هو المدى العالمي لهذه الرسالة؟",
        options: [
          "تخص الرومان فقط",
          "تعرض خطة الخلاص لكل البشرية",
          "تنتقد روما فقط",
          "عفا عليها الزمن"
        ],
        correctAnswer: 1,
        hint: "يتعلق بخطة الخلاص العالمية",
        funFact: "🌍 الإنجيل = قوة الله للجميع: يهود ويونانيين - عالمية كاملة!"
      }
    },

    85: {
      name: "نشيد المحبة - 1 كورنثوس 13",
      challenge: "إن كنت أتكلم بألسنة الناس والملائكة ولكن ليس لي محبة...",
      easy: {
        question: "أي إصحاح من الكتاب المقدس يُسمى 'نشيد المحبة'؟",
        options: [
          "1 كورنثوس 12",
          "1 كورنثوس 13",
          "1 يوحنا 4",
          "رومية 8"
        ],
        correctAnswer: 1,
        hint: "الإصحاح المركزي في 1 كورنثوس",
        funFact: "💝 الإصحاح الأكثر قراءة في حفلات الزفاف - تعريف كامل للمحبة!"
      },
      medium: {
        question: "ماذا يقول بولس عن مدة المحبة؟",
        options: [
          "المحبة تزول مع الوقت",
          "المحبة لا تسقط أبداً",
          "المحبة تعتمد على الظروف",
          "المحبة مؤقتة"
        ],
        correctAnswer: 1,
        hint: "أبدية المحبة الإلهية",
        funFact: "♾️ المحبة وحدها تعبر الموت والأبدية - القيمة العليا!"
      },
      hard: {
        question: "لماذا يضع بولس المحبة فوق المواهب الروحية؟",
        options: [
          "المواهب سيئة",
          "المحبة تعطي معنى وقيمة لكل شيء آخر",
          "المحبة أسهل",
          "المواهب تفرق"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالمحرك ومعنى كل خدمة",
        funFact: "🎯 بدون محبة، حتى أعظم المواهب تصبح ضجيجاً وكبرياء!"
      }
    },

    86: {
      name: "أفسس: الكنيسة جسد المسيح",
      challenge: "أخضع كل شيء تحت قدميه، وإياه جعل رأساً فوق كل شيء للكنيسة...",
      easy: {
        question: "حسب أفسس، ما هي الكنيسة في علاقتها بالمسيح؟",
        options: [
          "هيكله",
          "جسده",
          "عائلته",
          "جيشه"
        ],
        correctAnswer: 1,
        hint: "استعارة عضوية للوحدة",
        funFact: "👤 جسد المسيح: كل مسيحي عضو حيوي - ترابط متبادل!"
      },
      medium: {
        question: "أي سلاح يصفه بولس للحرب الروحية؟",
        options: [
          "سلاح جسدي",
          "سلاح الله الكامل: الحق، البر، السلام، الإيمان، الخلاص، كلمة الله",
          "سلاح روماني",
          "حماية سحرية"
        ],
        correctAnswer: 1,
        hint: "ست قطع من السلاح الروحي",
        funFact: "⚔️ حرب روحية بأسلحة روحية - استراتيجية إلهية للنصر!"
      },
      hard: {
        question: "ضد من حربنا الحقيقية حسب بولس؟",
        options: [
          "ضد البشر الأشرار",
          "ضد القوى الروحية للشر",
          "ضد الحكومات",
          "ضد الفقر"
        ],
        correctAnswer: 1,
        hint: "يتعلق بقوى روحية غير مرئية",
        funFact: "👹 حرب كونية: وراء الصراعات البشرية، حرب روحية حقيقية!"
      }
    },

    87: {
      name: "فيلبي: الفرح في المحنة",
      challenge: "افرحوا في الرب كل حين وأقول أيضاً افرحوا!",
      easy: {
        question: "ما الشعور الذي يشجعه بولس رغم سجنه؟",
        options: ["الاستسلام", "الفرح", "الغضب", "الحزن"],
        correctAnswer: 1,
        hint: "عاطفة مفاجئة لسجين",
        funFact: "😊 الفرح 16 مرة في 4 إصحاحات - رقم قياسي للسعادة في السجن!"
      },
      medium: {
        question: "حسب فيلبي 2، ما الموقف الذي اتخذه يسوع؟",
        options: [
          "فرض نفسه بالقوة",
          "أخلى وأذل نفسه حتى الموت",
          "هرب من مسؤولياته",
          "طلب المجد"
        ],
        correctAnswer: 1,
        hint: "حركة نزولية طوعية",
        funFact: "📉 يسوع: من المساواة مع الله إلى الموت على الصليب - محبة قصوى!"
      },
      hard: {
        question: "كيف يمكن لبولس أن يبشر بالفرح في السجن؟",
        options: [
          "يتظاهر",
          "الفرح المسيحي يتجاوز الظروف",
          "إنه مازوخي",
          "ينكر الواقع"
        ],
        correctAnswer: 1,
        hint: "يتعلق بفرح فوق طبيعي",
        funFact: "✨ الفرح = ثمر الروح مستقل عن الظروف - سر إلهي!"
      }
    },

    88: {
      name: "الرسائل الرعوية",
      challenge: "جاهد جهاد الإيمان الحسن، أمسك بالحياة الأبدية...",
      easy: {
        question: "لمن كتب بولس رسائله الرعوية الأخيرة؟",
        options: [
          "للكورنثيين",
          "لتيموثاوس وتيطس",
          "للرومان",
          "للغلاطيين"
        ],
        correctAnswer: 1,
        hint: "أبناؤه الروحيون ومساعدوه",
        funFact: "👨‍👦 وصية روحية: بولس ينقل الشعلة للجيل التالي!"
      },
      medium: {
        question: "ما النصيحة التي يعطيها بولس لاختيار قادة الكنيسة؟",
        options: [
          "اختيار الأغنى",
          "اختيار حسب معايير أخلاقية وروحية صارمة",
          "اختيار الأكثر تعليماً",
          "اختيار الأكثر شعبية"
        ],
        correctAnswer: 1,
        hint: "المؤهلات الأخلاقية قبل كل شيء",
        funFact: "⚖️ معايير عالية للقادة: الشخصية قبل الكفاءة - أولويات إلهية!"
      },
      hard: {
        question: "ما التراث الذي يتركه بولس لتيموثاوس؟",
        options: [
          "ممتلكات مادية",
          "الأمانة للإنجيل والخدمة الرعوية",
          "وظيفة سياسية",
          "مدرسة لاهوتية"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالميراث الروحي",
        funFact: "📜 'احفظ الوديعة الصالحة' - نقل أمين للإنجيل عبر العصور!"
      }
    },

    89: {
      name: "العبرانيين: يسوع رئيس الكهنة الأعظم",
      challenge: "لنا رئيس كهنة عظيم قد اجتاز السماوات...",
      easy: {
        question: "حسب العبرانيين، من هو رئيس كهنتنا العظيم؟",
        options: ["هارون", "موسى", "يسوع", "ملكي صادق"],
        correctAnswer: 2,
        hint: "الوسيط الكامل بين الله والبشر",
        funFact: "✝️ يسوع: كاهن وذبيحة - تضحية كاملة مرة واحدة للأبد!"
      },
      medium: {
        question: "لماذا كهنوت يسوع متفوق على كهنوت هارون؟",
        options: [
          "إنه أقدم",
          "إنه أبدي على رتبة ملكي صادق",
          "إنه أغنى",
          "إنه أكثر شعبية"
        ],
        correctAnswer: 1,
        hint: "الأبدية مقابل الزمنية",
        funFact: "♾️ كهنوت أبدي: يسوع يشفع فينا دائماً!"
      },
      hard: {
        question: "كيف يقدم العبرانيين العهد الجديد؟",
        options: [
          "مطابق للقديم",
          "متفوق ونهائي، مكتوب في القلوب",
          "مؤقت",
          "اختياري"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالإتمام والتجاوز",
        funFact: "📋 عهد جديد: الشريعة مكتوبة في القلوب، لا على الحجر!"
      }
    },

    90: {
      name: "يعقوب: الإيمان والأعمال",
      challenge: "الإيمان بدون أعمال ميت...",
      easy: {
        question: "حسب يعقوب، ما الذي يجب أن يرافق الإيمان؟",
        options: [
          "الأقوال",
          "الأعمال",
          "العواطف",
          "المعرفة"
        ],
        correctAnswer: 1,
        hint: "التعبير العملي عن الإيمان",
        funFact: "🌳 الإيمان = الجذر، الأعمال = الثمار - شجرة روحية كاملة!"
      },
      medium: {
        question: "بماذا يشبه يعقوب اللسان؟",
        options: [
          "بسيف",
          "بنار صغيرة تشعل غابة كبيرة",
          "بآلة موسيقية",
          "بأداة"
        ],
        correctAnswer: 1,
        hint: "عضو صغير لكن قوة تدميرية كبيرة",
        funFact: "🔥 اللسان: عضو صغير لكن يمكنه أن يشعل حياة كاملة - حذر!"
      },
      hard: {
        question: "كيف نوفق بين يعقوب وبولس حول الإيمان/الأعمال؟",
        options: [
          "يتناقضان",
          "بولس يتكلم عن التبرير، يعقوب عن التقديس",
          "أحدهما مخطئ",
          "لا يوجد حل"
        ],
        correctAnswer: 1,
        hint: "يتعلق بجانبين متكاملين",
        funFact: "⚖️ بولس: مخلصون بالإيمان / يعقوب: إيمان مُثبت بالأعمال - انسجام كامل!"
      }
    },

    91: {
      name: "الرؤيا: عودة الملك",
      challenge: "ها أنا آتي سريعاً. طوبى لمن يحفظ أقوال نبوة هذا الكتاب!",
      easy: {
        question: "لكم كنيسة يكتب يوحنا في سفر الرؤيا؟",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "عدد الكمال",
        funFact: "⛪ 7 كنائس آسيا: مرآة لجميع كنائس كل العصور!"
      },
      medium: {
        question: "كيف تنتهي القصة حسب سفر الرؤيا؟",
        options: [
          "دمار كامل",
          "سماوات جديدة وأرض جديدة",
          "عودة إلى الفردوس الأرضي",
          "نهاية كل وجود"
        ],
        correctAnswer: 1,
        hint: "تجديد كامل للخليقة",
        funFact: "🌅 ليس نهاية العالم بل تجديد كامل - رجاء نهائي!"
      },
      hard: {
        question: "ما الرسالة المركزية التي ينقلها سفر الرؤيا للمضطهدين؟",
        options: [
          "استسلموا",
          "المسيح يملك وسينتصر نهائياً",
          "اهربوا من الاضطهاد",
          "انتقموا"
        ],
        correctAnswer: 1,
        hint: "يتعلق بالرجاء في الانتصار النهائي",
        funFact: "👑 'الذي كان والكائن والآتي' - رب التاريخ والزمن!"
      }
    }
  }
};

export default chapter7Translations;
